/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_modal: 'modalStatus/set_modal',
    set_modal_mode: 'modalStatus/set_modal_mode',
    set_filter_mode: 'modalStatus/set_filter_mode',
}

// count state 必須是 Object
const state = {
    modal: {
        //房東
        newAllBill: false,
        newBill: false,
        newAccounting: false,
        editAccounting: false,
        billDetail: false,
        contractRelease: false,
        virtualAccount: false,
        viewHouse: false,
        autoCreate: false,
        autoSend: false,
        autoSettingBatch: false,
        addNickName: false,
        shareSocialMedia: false,
        evaluationCommentModal: false,
        notPublish: false,
        landlordAuthModal: false,
        downloadApp: false,
        downloadAppMb: false,
        verifiedAlarm: false,
        payAtmDetail: false,
        payWalletDetail: false,
        platformFeeInfo: false,
        walletStoredInfo: false,
        refundDetail: false,
        ledgerDetail: false,
        taskDetail: false,
        howToSetTaskTime: false,
        howToSetTaskBonus: false,
        howToSetTasker: false,
        taskTutorial: false,
        mobileRedirect: false,
        resetPwd: false,
        resendEmailVerified: false,
        //企業
        bizWaitVerified: false,
        bizAddNickName: false,
        bizAddEquips: false,
        bizNewBill: false,
        bizAutoCreate: false,
        bizAutoSend: false,
        bizTaskPaymentRecord: false,
        bizTaskTutorial: false,
        bizViewHouse: false,
        bizVirtualAccount: false,
        bizPayAtmDetail: false,
        bizPayWalletDetail: false,
        bizPaymentAll: false,
        bizBillDetail: false,
        bizCheckIn: false,
        bizNewLedger: false,
        bizEditLedger: false,
        bizImportMeterRecord: false,
        bizReleaseAppeal: false,
        bizAutoSettingBatch: false,
        bizRefundDetail: false,
        bizLedgerDetail: false,
        bizTaskDetail: false,
        bizShareSocialMedia: false,
        bizEditHouseGroup: false,
        bizAddPolicyToNow: false,
        bizAllInsteadPolicy: false,
        bizAllInsteadLandlord: false,
        bizAllInsteadGroupAndSales: false,
        bizNotifyMeterBatch: false,
        bizMemberList: false,
        bizCropper: false,
        resetUserPwd: false,
        bizWalletStoredInfo: false,
        bizWalletWithdraw: false,
        bizNewAllBill: false,
        bizContractRelease: false,
        verifiedEmailHasSent: false,
        bizLeaseEvaluation: false,
        bizNoRight: false,
        signatureQrcode: false,
        bizAnnouncement: false,
        bizChooseContractType: false,
        bizBookingContractVersion: false,
        bizBatchContractVersion: false,
        bizNewManager: false,
        bizChooseManager: false,
        bizUploadRecord: false,
        bizRecommandTenantDetail: false,
        // 洽談合作
        contactSuccess: false
    },
    isModalMode: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_MODAL_STATUS: (state) => {
        return state.modal
    },
    GET_MODAL_MODE: (state) => {
        return state.isModalMode
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    setModalStatus ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            commit(types.set_modal_mode, data.state)
            commit(types.set_modal, data)
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_modal](state, data){
        state.modal[data.type] = data.state
    },
    [types.set_modal_mode](state, data){
        if(data){
            document.documentElement.style.overflowY = 'hidden'; 
            if(document.getElementsByClassName('biz-tool-bar').length){
                document.getElementsByClassName('biz-tool-bar')[0].style.zIndex = '7'
            }
        }else{
            document.documentElement.style.overflowY = 'scroll'; 
        }
        if(data == false && document.getElementsByClassName('parent-frame').length){
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
        }
        if(data == false &&  document.getElementsByClassName('biz-tool-bar').length){
            document.getElementsByClassName('biz-tool-bar')[0].style.zIndex = '8'
        }
        state.isModalMode = data
    },
    [types.set_filter_mode](state, data){
        if(data == false && document.getElementsByClassName('parent-frame').length){
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
        }
        if(data == false &&  document.getElementsByClassName('biz-tool-bar').length){
            document.getElementsByClassName('biz-tool-bar')[0].style.zIndex = '8'
        }
        state.isModalMode = data
    }
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/global/modalStatus.js